import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 85,
	height: 85,
	viewBox: "0 0 85 85",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2886_152112)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M46.1331 48.8649C44.2516 50.7937 41.1451 50.8053 39.2518 48.8883L14.6753 24.0421C13.8137 24.9071 13.2803 26.0995 13.2803 27.4145V57.6846C13.2803 60.3265 15.4314 62.4715 18.0807 62.4715H66.9173C69.5667 62.4715 71.7178 60.3265 71.7178 57.6846V27.4145C71.7178 26.1053 71.1903 24.913 70.3286 24.048L46.1331 48.8649Z",
			fill: "#94DCFF"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M46.135 48.865L70.3306 24.0481C69.4631 23.1714 68.2557 22.6278 66.9193 22.6278H18.0827C16.7522 22.6278 15.5506 23.1655 14.6772 24.0422L39.2538 48.8884C41.1529 50.8055 44.2535 50.7938 46.135 48.865Z",
			fill: "#00ABFF"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2886_152112",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 58.4375,
			height: 39.8438,
			fill: "white",
			transform: "translate(13.2812 22.6265)"
		})
	}) })]
});
export default SvgIconMessage;
